type ParentNode = {
  type?: string | null;
  data?: { readableId?: string };
};

const NATIVE_QUAKE_CREATE_NOTE_ACTION_ID = "native-quake-create-note";

/**
 * Supplies mappings required by an action when it is added inside a container.
 *
 * Candidate Record Batch yields a claim, not individual candidate records. The
 * Create Note action consumes that claim to bulk-create and link one note for
 * every candidate in the batch.
 */
export function getContextualActionParameters({
  actionId,
  parentNode,
}: {
  actionId: string;
  parentNode?: ParentNode;
}) {
  if (actionId !== NATIVE_QUAKE_CREATE_NOTE_ACTION_ID || parentNode?.type !== "candidateRecordBatch") {
    return undefined;
  }

  const parentReadableId = parentNode.data?.readableId;
  if (!parentReadableId) return undefined;

  return [
    {
      location: "arguments" as const,
      input: {
        candidate_batch: `{{ ${parentReadableId}.candidate_batch }}`,
      },
    },
  ];
}
